import React from 'react';
import { Quote } from 'lucide-react';

const Testimonials = ({ testimonials }) => {
  return (
    <section className="section-padding testimonials-section" id="testimonials">
      <div className="container">
        <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '80px' }}>What Clients Say</h2>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <Quote className="quote-icon" />
              <p className="body-large testimonial-quote">{testimonial.quote}</p>
              <div className="testimonial-author">
                <p className="body-regular" style={{ fontWeight: '700' }}>{testimonial.author}</p>
                <p className="body-small" style={{ color: 'var(--text-secondary)' }}>{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;